export enum ReviewStatus {
  approved = "approved",
  pending = "pending",
  rejected = "rejected",
}
